// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: 'http://panel.sacyl.staging.educativa.es/api/v1/',
  baseUrl: 'http://panel.sacyl.staging.educativa.es/',
  paymentsUrl: "http://fenix-payments.test/",        
  apiKeyMap: "",
  auth: {
    clientSecret: "xGbAhWL960HycCoboFNvKdhpWJxnLdxIs55Gjn95",
    clientId: "2",
  },
  adminBaseUrl: "http://admin.sacyl.test/password/reset",
}; 

import 'zone.js/dist/zone-error';  // Included with Angular CLI.
